import { store } from '../store/index.js';
import { addExecutedOnLoad } from '../store/reducers/executionSlice.js';
import { flowExecutor } from './be-connector.js';
import { getAttrValue } from './propChecker.js';

const filterByPage = (variables, pageId) => {
    const appVars = Object.fromEntries(Object.entries(variables.app).map(([id, variable]) => {
        return [id, variable.value];
    }));
    const pageVars = Object.fromEntries(Object.entries(variables.page[pageId]).map(([id, variable]) => {
        return [id, variable.value];
    }));
    return {
        app: appVars,
        page: pageVars
    };
};
const eventParser = (events, variables, component, pageId) => {
    return Object.fromEntries(Object.entries(events).map(([eventName, events]) => {
        return [
            eventName,
            (e) => {
                events.forEach((event) => {
                    const id = event.exec;
                    const params = getFlowParams(event.params, variables, component);
                    const isEventObject = e && typeof e === "object" && "target" in e;
                    if (event.stopPropagation) {
                        e.stopPropagation();
                    }
                    if (event.preventDefault) {
                        e.preventDefault();
                    }
                    if (!id)
                        return;
                    if (eventName === "onActionButtonClick" && event.eventData.buttonId !== e.buttonIndex)
                        return;
                    if (store.getState().engineProperties.mode === "live") {
                        store.dispatch(addExecutedOnLoad(id));
                        const variables = filterByPage(store.getState().variables, pageId);
                        // prepare input object
                        const input = Object.assign(Object.assign(Object.assign({}, params), variables), { component });
                        input.event = e;
                        if (!isEventObject) {
                            input.input = e;
                        }
                        flowExecutor.trigger(id, input);
                    }
                });
            }
        ];
    }));
};
const getFlowParams = (params, variables, component) => {
    if (!params)
        return {};
    return Object.fromEntries(Object.entries(params).map(([key, value]) => {
        return [key, getAttrValue(value, Object.assign(Object.assign({}, variables), { component: component }))];
    }));
};

export { eventParser, filterByPage, getFlowParams };
//# sourceMappingURL=eventParser.js.map
